import { isPathInControlZone } from 'ducks/zone'
import { useLocation } from 'react-router-dom'

export const useAdaPositioning = () => {
  const location = useLocation()

  const isOnDesignPage = location.pathname.includes('/design')
  const isOnExplorePage = location.pathname.includes('/explore')
  const isOnHomePage = location.pathname === '/home' || location.pathname === '/'
  const isOnProposalPage = location.pathname.includes('/proposal')
  const isOnCashFlowConfigurePage =
    location.pathname.includes('/cashflow/configure') &&
    !location.pathname.includes('/cashflow/configure/accounting') &&
    !location.pathname.includes('/cashflow/configure/documents')
  const isOnPaymentRequestsPage = location.pathname.includes('/payment?')

  const isInControlZoneAndCrud = () => {
    const isInControlZone = isPathInControlZone(location.pathname)
    if (!isInControlZone) return false

    const pathSegments = location.pathname.split('/')
    const hasCrudOperation = pathSegments.some(
      (segment) => segment === 'create' || /^\d+$/.test(segment) || /^[a-f0-9-]{8,}$/i.test(segment)
    )

    return hasCrudOperation
  }

  const isInControlZone = isInControlZoneAndCrud()

  const shouldElevate =
    isInControlZone || isOnHomePage || isOnExplorePage || isOnProposalPage || isOnCashFlowConfigurePage

  return {
    isOnDesignPage,
    isOnExplorePage,
    isOnHomePage,
    isInControlZone,
    shouldElevate,
    isOnProposalPage,
    isOnCashFlowConfigurePage,
    isOnPaymentRequestsPage,
  }
}
